<template>
  <div class="tiptap-editor" :class="{ 'disable-edit': !disableEdit }">
    <editor-menu-bar :editor="editor">
      <div slot-scope="{ commands, isActive }">
        <div class="menubar">
          <i class="fas fa-bold menubar__button"
             @click="commands.bold"
             :class="{ 'is-active': isActive.bold() }"
          ></i>
          <i class="fas fa-italic menubar__button"
             @click="commands.italic"
             :class="{ 'is-active': isActive.italic() }"
          ></i>
          <i class="fas fa-list-ul menubar__button"
             @click="commands.bullet_list"
             :class="{ 'is-active': isActive.bullet_list() }"
          ></i>
          <i class="fas fa-list-ol menubar__button"
             @click="commands.ordered_list"
             :class="{ 'is-active': isActive.ordered_list() }"
          ></i>
        </div>
      </div>
    </editor-menu-bar>
    <editor-content
      :editor="editor"
      class="tiptap-content"
    />
  </div>
</template>

<script>
  import {Editor, EditorContent, EditorMenuBar} from 'tiptap'
  import {
    OrderedList,
    BulletList,
    ListItem,
    Bold,
    Italic,
  } from 'tiptap-extensions'

  export default {
    props: {
      content: String,
      disableEdit: {
        default: true,
        type: Boolean
      }
    },
    components: {
      EditorMenuBar,
      EditorContent,
    },
    data() {
      return {
        editor: null,
        editorChange: false,
        disableEditing: true
      };
    },
    mounted() {
      this.editor = new Editor({
        extensions: [
          new BulletList(),
          new ListItem(),
          new OrderedList(),
          new Bold(),
          new Italic(),
        ],
        tightLists: false,
        content: this.value,
        onUpdate: ({getHTML}) => {
          this.editorChange = true;
          this.$emit('input', getHTML())
        },
      })
      this.editor.setContent(this.content)
    },
    beforeDestroy() {
      if (this.editor) this.editor.destroy();
    },
    watch: {
      content(val) {
        if (this.editor && !this.editorChange) {
          this.editor.setContent(val, true);
        }
        this.editorChange = false;
      }
    },
  }
</script>

<style lang="scss">
  .disable-edit {
    pointer-events: none;
    background-color: #f1f1f1 !important;

    .is-active {
      color: inherit !important;
    }
  }

  .tiptap-editor {
    .menubar {
      background: #f6f6f6;
      padding: 5px 10px;
      border: 1px solid #ebebeb;

      .menubar__button {
        margin-right: 15px;

        &.is-active {
          color: #25b7bc;
        }
      }
    }

    .tiptap-content {
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: #ebebeb;

      .ProseMirror {
        padding: 15px;
        min-height: 150px;

        &:focus {
          outline: 0;
        }
      }
    }
  }
</style>